import axios from "axios";

const URI = "https://api.gt7.com.br/cdtsite/checkout/services/18";

export async function getPricesCdt() {
  try {
    const { data } = await axios.get(URI, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return data;
  } catch (e) {
    console.error("Erro ao buscar os preços da API:", e);
    return {
      anuidadeTimes: "0",
      clinico_geral: 0,
      dateTime: "",
      demais: 0,
      valor: "0",
    };
  }
}
